import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { ManageAddons } from './main/ManageAddons';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ManageSMSAddon } from './main/ManageSMS';
import { ManageAnnotations } from './main/ManageAnnotations';
import { ManageCaptions } from './main/ManageCaptions';
import { ManageFiles } from './main/ManageFiles';
import { WheelsTVAddon } from './main/WheelsTV';
import { useAuth } from 'lib/context';
import { useTranslation } from 'react-i18next';
import {
  checkIfFeatureIsEnabled,
  productFeature,
} from 'lib/utils/productFeature';
import { NotFoundTemplate } from 'app/pages/notFound';

export const AddOns = () => {
  const { t } = useTranslation();
  const [isSMSDisabled, setIsSmsDisabled] = React.useState(false);
  const [isCaptionsDisabled, setIsCaptionsDisabled] = React.useState(false);
  const [isAnnotationsDisabled, setIsAnnotationsDisabled] =
    React.useState(false);
  const [isFilesDisabled, setIsFilesDisabled] = React.useState(false);
  const [isWheelsTvDisabled, setIsWheelsTvDisabled] = React.useState(false);

  const { userData } = useAuth();

  React.useEffect(() => {
    const packageDetails = userData.user?.packageDetails;
    if (!packageDetails || packageDetails.id == 0 || !packageDetails.products) {
      return;
    }

    const isSMSDisabled = !checkIfFeatureIsEnabled(
      userData,
      productFeature.SMS_ADMIN_CONTROLS
    );

    const isCaptionsDisabled = !checkIfFeatureIsEnabled(
      userData,
      productFeature.CAPTIONS
    );

    const isAnnotationsDisabled = !checkIfFeatureIsEnabled(
      userData,
      productFeature.ANNOTATIONS
    );

    const isFilesDisabled = !checkIfFeatureIsEnabled(
      userData,
      productFeature.FILES_AND_BOARDS
    );

    const isWheelsTvDisabled = !checkIfFeatureIsEnabled(
      userData,
      productFeature.WTV
    );

    setIsAnnotationsDisabled(isAnnotationsDisabled);
    setIsCaptionsDisabled(isCaptionsDisabled);
    setIsFilesDisabled(isFilesDisabled);
    setIsWheelsTvDisabled(isWheelsTvDisabled);
    setIsSmsDisabled(isSMSDisabled);
  }, []);

  return (
    <Switch>
      <Route path='/profile/add-ons/sms/manage'>
        {!isSMSDisabled ? (
          <>
            <DocumentHead title={t('Add-Ons')} />
            <PageTemplate main={<ManageSMSAddon />} showNavigation={false} />
          </>
        ) : (
          <Redirect to='/upgrade-plan' />
        )}
      </Route>
      <Route path='/profile/add-ons/sf/manage'>
        {!isAnnotationsDisabled ? (
          <>
            <DocumentHead title={t('Add-Ons')} />
            <PageTemplate main={<ManageAnnotations />} showNavigation={false} />
          </>
        ) : (
          <Redirect to='/upgrade-plan' />
        )}
      </Route>
      <Route path='/profile/add-ons/captions/manage'>
        {!isCaptionsDisabled ? (
          <>
            <DocumentHead title={t('Add-Ons')} />
            <PageTemplate main={<ManageCaptions />} showNavigation={false} />
          </>
        ) : (
          <Redirect to='/upgrade-plan' />
        )}
      </Route>
      <Route path='/profile/add-ons/files/manage'>
        {!isFilesDisabled ? (
          <>
            <DocumentHead title={t('Files Add-On')} />
            <PageTemplate main={<ManageFiles />} showNavigation={false} />
          </>
        ) : (
          <Redirect to='/upgrade-plan' />
        )}
      </Route>

      <Route path='/profile/add-ons/wheels-tv/details'>
        {!isWheelsTvDisabled ? (
          <>
            <DocumentHead title={t('Add-Ons')} />
            <PageTemplate main={<WheelsTVAddon />} showNavigation={false} />
          </>
        ) : (
          <Redirect to='/upgrade-plan' />
        )}
      </Route>
      <Route path='/profile/add-ons' exact>
        <>
          <DocumentHead title={t('Add-Ons')} />
          <PageTemplate main={<ManageAddons />} showUpgradeToday={true} />
        </>
      </Route>
      <Route path='*' component={NotFoundTemplate} />
    </Switch>
  );
};
